import { render, staticRenderFns } from "./EditParameterModal.vue?vue&type=template&id=8e882b56"
import script from "./EditParameterModal.vue?vue&type=script&lang=js"
export * from "./EditParameterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports